function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ToggleAction from "./components/ToggleAction";
import _ from "lodash";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from '@fortawesome/free-solid-svg-icons';
const StyledTriggerWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 2.5rem;
`;
const StyledTriggerContent = styled.p`
  flex-shrink: 0;
  margin: 0.3rem
`;

class ToggleCreate extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(ToggleAction, _extends({}, this.props, {
        trigger: /*#__PURE__*/React.createElement(StyledTriggerWrapper, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faPlus
        }), /*#__PURE__*/React.createElement(StyledTriggerContent, null, "Add ", _.capitalize(this.props.type))),
        submitText: `Add ${_.capitalize(this.props.type)}`,
        placeholder: `Enter a title for new ${this.props.type}...`,
        clearAfterAction: true,
        onClick: e => e.stopPropagation(),
        cypress: this.props.cypress
      }));
    });
  }

}

export default ToggleCreate;